export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-view-button-1.0.0',
    name: 'JDSDatepickerViewButton'
  },
  hierarchy: {
    'root-container': [
      {
        container: ['jds_button']
      }
    ]
  },
  base: {
    'root-container': {
      width: '{d_0}',
      'flex-direction': '{d_1}',
      'justify-content': '{d_2}',
      'align-items': '{d_3}'
    },
    container: {
      height: '{d_4}',
      width: '{d_5}',
      'flex-direction': '{d_6}',
      'justify-content': '{d_7}',
      'align-items': '{d_8}'
    },
    jds_button: {
      kind: 'tertiary',
      size: 'medium',
      fullWidth: true,
      state: 'normal'
    }
  },
  variant: {
    selected: {
      true: {
        jds_button: {
          kind: 'primary'
        }
      }
    },
    disabled: {
      true: {
        jds_button: {
          disabled: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      disabled: {
        values: [false, true]
      },
      selected: {
        values: [false, true]
      }
    },
    data: {
      jds_button: {
        label: {
          type: 'string',
          name: 'name'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      }
    },
    events: {
      jds_button: {
        onClick: 'onSelect'
      }
    },
    a11y: {
      jds_button: {
        properties: {
          ariaLabel: 'ariaLabel'
        }
      },
      container: {
        properties: {
          role: {
            value: 'listitem'
          }
        }
      }
    }
  }
};
